// 正恒招标
export default {
    nav: [
        {
            title: '首页',
            href: '/',
            activeReg: /(^\/search*)|(^\/$)/,
        },
        {
            title: '新闻公告',
            href: '/news',
            activeReg: /(^\/news*)/,
        },
        {
            title: '交易信息',
            href: '/business',
            activeReg: /(^\/business*)/,
        },
        {
            title: '办事指南',
            href: '/guide',
            activeReg: /(^\/guide*)/,
        },
        {
            title: '下载中心',
            href: '/download',
            activeReg: /(^\/download*)/,
        },
        {
            title: '关于我们',
            href: '/about',
            activeReg: /(^\/about*)/,
        },
    ],
    head: {
        title: '山东正恒招投标电子交易平台',//全称
        title2: '山东正恒招投标电子交易平台',//简称
        jc_title: '正恒招标',//简称
        citycode:'370000',//城市编号
        planName:'sdzh',
        caType:'',
        meta: {
            description: '山东正恒招投标电子交易平台,交易平台,招投标,电子交易平台',
            keywords: '山东正恒招投标电子交易平台,交易平台,招投标,电子交易平台',
        },
        favicon: '/sdzh/favicon.ico',
        logoUrl: '/sdzh/images/logo.png',//首页LOGO
        logoStyle: {
            maxWidth: '320px',
        },
        loginImgUrl: '',
        registerImg: '',//注册页面LOGO
        bannerList:[
            {
                linkimg:'/images/banner.png',
                linkurl:''
            }
        ],
        tbLoginUrl:'http://sdzhtb.zchzb.com/newtbr/index.html#/login?plan=sdzh',
        homeShowRegisterNum: true,//首页显示入驻机构
        showFloatLayer: true,//首页悬浮框
        // 用户角色登录
        userRoles: [
            {
                imgsrc: '',
                href: 'http://sdzhdl.zchzb.com/otc/#/login?plan=sdzh&mRole=agent',
                title: '代理机构登录',
                class: 'primary',
            },
            {
                imgsrc: '',
                href: 'http://sdzhtb.zchzb.com/newtbr/index.html#/login?plan=sdzh',
                title: '投标人/供应商登录',
                class: 'primary',
            },
            {
                imgsrc: '',
                href: 'http://sdzhpb.zchzb.com/feature/sdzh?plan=sdzh',
                title: '专家登录',
                class: 'primary'
            },
            {
                imgsrc: '',
                href: 'http://sdzhdl.zchzb.com/otc/#/login?plan=sdzh&mRole=tender',
                title: '采购人/招标人登录',
                class: 'primary',
            },
        ],
        userRolesZfcg:[],
        friendLinks:[],
        tel: '0534-5755888', //客服电话
        tel2: '',//备用电话/其他电话
        fax: '',//传真号码
        email: 'sdzhgcxm@163.com', //邮箱地址
        workTime: '',//工作时间
        postalCode: '',//邮政编码
        companyName: '山东正恒工程项目管理有限公司',  //运营公司名称
        companyAddress: '山东省德州市齐河县晏城街道黄河大道10号金融中心D座7楼707室',//公司地址
        companyLatLng:{ lng: 0, lat: 0 },//公司地址坐标
        showWeather: false,//是否显示天气
        icp:'京ICP备2020039654号-1',
        gwIcp:'',
        isCheckOtherSingleCertCode: true, //注册页面 是否校验 其他一证一照代码
    },
    proxy: {
        '/web': {
            target: 'http://sdzh.zchzb.com/',
            changeOrigin:true,
        },
    },
}